var dreamWiseEplorerClass = null;

(function () {

  $("#btn-newsletter").on("click", function (e) {
    e.preventDefault();
    $(".error_name").css("display", "none");
    $(".error_server").css("display", "none");
    var customerName = $.trim($("#contact_name").val());
    if (customerName == "") {
      $(".error_name").css("display", "block");
    } else {
      $("#btn-newsletter").addClass("loading");
      $("#btn-newsletter").attr("disabled", "disabled");
      try {
        const response = fetch("https://dwshopify-bhcta4hacucegahc.eastus-01.azurewebsites.net/newsletter.php", {
          method: "POST",
          body: JSON.stringify({
            id: window.dreamexplorer.customer_id,
            name: customerName,
            lang: window.dreamexplorer.lang,
          }),
        });
        response
          .then((res) => {
            return res.json();
          })
          .then((res) => {
            $("#btn-newsletter").removeAttr("disabled");
            $("#btn-newsletter").removeClass("loading");
            if (res.status) {
              window.location.href = window.location.href;
            } else {
              $(".error_server").css("display", "block");
            }
          });
      } catch (error) {
        $("#btn-newsletter").removeAttr("disabled");
        $("#btn-newsletter").removeClass("loading");
        $(".error_server").css("display", "block");
      }
    }
  });
})();
class DreamRecorder {
  constructor() {
    this.mediaRecorder = null;
    this.audioChunks = [];
    this.isRecording = false;
    this.microphonePermission = null;
    this.session_id = null;
    this.speechTokenEndpoint = "https://dwshopify-bhcta4hacucegahc.eastus-01.azurewebsites.net/speech-token.php";
    this.regionOptions = null;
    this.speechAuthorizationToken = null;
    this.audioConfig = null;
    this.speechConfig = null;
    this.speechRecognizer = null;

    // New Web Audio API vars
    this.audioContext = null;
    this.mediaStream = null;
    this.scriptProcessor = null;
    this.audioBuffer = [];
    this.bufferSize = 4096; // scriptProcessor buffer size
    this.sampleRate = 44100;

    this.conversation_id = new Date().getTime();
    this.recordBtn = document.getElementById("recordBtn");
    this.submitBtn = document.getElementById("submitBtn");
    this.trashBtn = document.getElementById("trashBtn");
    this.cancelRecordingBtn = document.getElementById("cancel-recording-btn");
    this.dreamText = document.getElementById("dreamText");
    this.dreamTextHidden = document.getElementById("dreamTextHidden");
    this.statusMessage = document.getElementById("statusMessage");
    this.dreamForm = document.getElementById("dreamForm");
    this.permissionModal = document.getElementById("permissionModal");
    this.allowMicBtn = document.getElementById("allowMicBtn");
    this.denyMicBtn = document.getElementById("denyMicBtn");
    this.dreamResult = document.getElementById("dreamResult");
    this.userDreamDisplay = document.getElementById("userDreamDisplay");
    this.interpretationIntro = document.getElementById("interpretationIntro");
    this.interpretationKey = document.getElementById("interpretationKey");
    this.interpretationDetail = document.getElementById("interpretationDetail");
    this.message_id = null;
    this.initializeEventListeners();
    this.checkMicrophonePermission();
  }

  // Initialize event listeners
  initializeEventListeners() {
    this.recordBtn.addEventListener("click", () => this.handleRecordClick());
    this.dreamForm.addEventListener("submit", (e) => this.handleSubmit(e));
    this.trashBtn.addEventListener("click", () => this.handleTrashClick());
    this.allowMicBtn.addEventListener("click", () => this.requestMicrophonePermission());
    this.denyMicBtn.addEventListener("click", () => this.hidePermissionModal());

    $("#dreamResult").on("click", ".copyBtn", function (e) {
      e.preventDefault();
      var fullInterpretation = $(this).parent().prev().find(".interpretation-detail").text();
      var $this = this;
      navigator.clipboard
        .writeText(fullInterpretation)
        .then(() => {
          dreamWiseEplorerClass.copyFeedback($(".copyBtn")[0]);
        })
        .catch(() => {
          // Fallback for older browsers
          const textArea = document.createElement("textarea");
          textArea.value = fullInterpretation;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          document.body.removeChild(textArea);
          dreamWiseEplorerClass.copyFeedback($(".copyBtn")[0]);
        });
    });

    $("#dreamResult").on("click", ".likeBtn", async function (e) {
      e.preventDefault();
      if (!$(this).hasClass("like")) {
        var $that = $(this);
        $that.attr("disabled", "disabled");
        dreamWiseEplorerClass.message_id = $that.parent().data("message-id");
        try {
          const response = await fetch("https://dwshopify-bhcta4hacucegahc.eastus-01.azurewebsites.net/dream-thumbs-up.php", {
            method: "POST",
            body: JSON.stringify({
              lang: window.dreamexplorer.lang,
              customer_id: window.dreamexplorer.customer_id,
              conversation_id: dreamWiseEplorerClass.conversation_id,
              message_id: dreamWiseEplorerClass.message_id,
            }),
          });

          if (response.ok) {
            const result = await response.json();
            if (result.status) {
              $that.addClass("like");
              $that.next().removeClass("dislike");
              const actionButtons = document.querySelector(".action-buttons");
              dreamWiseEplorerClass.showFeedbackNotification($(this).parent().get(0));
            } else {
              dreamWiseEplorerClass.showStatus(window.dreamexplorer.server_error, "error");
            }
          } else {
            dreamWiseEplorerClass.showStatus(window.dreamexplorer.server_error, "error");
          }
        } catch (error) {
          console.error("Submit error:", error);
          dreamWiseEplorerClass.showStatus(window.dreamexplorer.server_error, "error");
        } finally {
          $that.removeAttr("disabled");
        }
      }
    });

    $("#dreamResult").on("click", ".dislikeBtn", async function (e) {
      e.preventDefault();
      if (!$(this).hasClass("dislike")) {
        var $that = $(this);
        $that.attr("disabled", "disabled");
        dreamWiseEplorerClass.message_id = $that.parent().data("message-id");
        try {
          const response = await fetch("https://dwshopify-bhcta4hacucegahc.eastus-01.azurewebsites.net/dream-thumbs-down.php", {
            method: "POST",
            body: JSON.stringify({
              lang: window.dreamexplorer.lang,
              customer_id: window.dreamexplorer.customer_id,
              conversation_id: dreamWiseEplorerClass.conversation_id,
              message_id: dreamWiseEplorerClass.message_id,
            }),
          });

          if (response.ok) {
            const result = await response.json();
            if (result.status) {
              $that.addClass("dislike");
              $that.prev().removeClass("like");
              // Show feedback box
              dreamWiseEplorerClass.showFeedbackBox($that.parent());
            } else {
              dreamWiseEplorerClass.showStatus(window.dreamexplorer.server_error, "error");
            }
          } else {
            dreamWiseEplorerClass.showStatus(window.dreamexplorer.server_error, "error");
          }
        } catch (error) {
          console.error("Submit error:", error);
          dreamWiseEplorerClass.showStatus(window.dreamexplorer.server_error, "error");
        } finally {
          $that.removeAttr("disabled");
        }
      }
    });

    $("#dreamResult").on("click", ".closeBtn", function (e) {
      e.preventDefault();
      dreamWiseEplorerClass.conversation_id = new Date().getTime();
      $("#dreamForm").removeClass("again");
      $("#dreamResult").removeClass("show");
      $("#dreamResult").empty();
      $("#dreamText").val("");
      $("#dreamText").attr("placeholder", window.dreamexplorer.form_dream_placeholder);
    });

    // Handle feedback box close button
    $("#dreamResult").on("click", ".feedback-close-btn", function (e) {
      e.preventDefault();
      $(this).closest(".feedback-box").remove();
    });

    // Handle feedback tag selection
    $("#dreamResult").on("click", ".feedback-tag", function (e) {
      e.preventDefault();
      const $tag = $(this);
      const $feedbackBox = $tag.closest('.feedback-box');
      const $options = $feedbackBox.find('.feedback-options');
      var elActionButtons = $(this).parents(".feedback-box").prev().get(0);
      // Remove selected class from all feedback tags in this feedback box
      $tag.siblings('.feedback-tag').removeClass("selected");
      // Add selected class to clicked tag
      $tag.addClass("selected");

      // If last tag clicked, show textarea + submit instead of buttons
      if ($tag.is(':last-child')) {
        const placeholder = (window.dreamexplorer && window.dreamexplorer.feedback_other_placeholder) || 'Write here';
        const textareaHtml = `
          <div class="feedback-freeform">
            <textarea class="feedback-textarea" placeholder="${placeholder}"></textarea>
            <button class="feedback-submit-btn" type="button" title="Submit"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
            <path fill="currentColor" d="M11.9998 2.11804C12.4546 2.11804 12.8233 2.48853 12.8233 2.94554V21.1505C12.8233 21.6076 12.4546 21.978 11.9998 21.978C11.545 21.978 11.1763 21.6076 11.1763 21.1505V2.94554C11.1763 2.48853 11.545 2.11804 11.9998 2.11804Z" clip-rule="evenodd" fill-rule="evenodd"></path>
            <path fill="currentColor" d="M11.4178 2.36041C11.7394 2.03725 12.2608 2.03725 12.5824 2.36041L19.9939 9.80791C20.3155 10.1311 20.3155 10.655 19.9939 10.9782C19.6723 11.3013 19.1509 11.3013 18.8293 10.9782L12.0001 4.1158L5.17094 10.9782C4.84934 11.3013 4.32793 11.3013 4.00633 10.9782C3.68474 10.655 3.68474 10.1311 4.00633 9.80791L11.4178 2.36041Z" clip-rule="evenodd" fill-rule="evenodd"></path>
            </svg>
            </button>
          </div>
        `;
        $options.html(textareaHtml);
        return;
      }

      // For other tags: submit reason, close box and notify
      const selectedText = $tag.text().trim();
      dreamWiseEplorerClass.submitFeedbackReason(selectedText);

      // Close the feedback box
      $feedbackBox.remove();

      // Trigger feedback notification
      if (dreamWiseEplorerClass && typeof dreamWiseEplorerClass.showFeedbackNotification === 'function') {
        console.log($(this));
        console.log($(this).parents(".feedback-box").prev().get(0));
        dreamWiseEplorerClass.showFeedbackNotification(elActionButtons);
      }
    });

    // Handle feedback freeform submit
    $("#dreamResult").on("click", ".feedback-submit-btn", function (e) {
      e.preventDefault();
      var elActionButtons = $(this).parents(".feedback-box").prev().get(0);
      const $container = $(this).closest('.feedback-box');
      const reason = $container.find('.feedback-textarea').val().trim();
      if (!reason) {
        return;
      }
      dreamWiseEplorerClass.submitFeedbackReason(reason);
      $container.remove();
      if (dreamWiseEplorerClass && typeof dreamWiseEplorerClass.showFeedbackNotification === 'function') {
        dreamWiseEplorerClass.showFeedbackNotification(elActionButtons);
      }
    });

    $("textarea")
      .each(function () {
        this.style.height = this.scrollHeight + "px";
        this.style.overflowY = "hidden";
      })
      .on("input", function () {
        this.style.height = "auto";
        this.style.height = this.scrollHeight + "px";
      });

    this.initializeSpeechSDK(async (speechSdk) => {
      window.SpeechSDK = speechSdk;
      if (typeof this.requestAuthorizationToken === "function") {
        await this.requestAuthorizationToken();
      }
    });

    
  }

  handleTrashClick() {
    $(".trash-btn").css('display', 'none');
    this.dreamTextHidden.value = "";
    this.dreamText.value = "";
  }

  async submitFeedbackReason(selectedText) {
    try {
      const response = await fetch("https://dwshopify-bhcta4hacucegahc.eastus-01.azurewebsites.net/dream-thumbs-down-reason.php", {
        method: "POST",
        body: JSON.stringify({
          lang: window.dreamexplorer.lang,
          customer_id: window.dreamexplorer.customer_id,
          conversation_id: dreamWiseEplorerClass.conversation_id,
          message_id: dreamWiseEplorerClass.message_id,
          reason: selectedText,
        }),
      });
    } catch (error) {
      console.error("Submit error:", error);
    }
  }

  // Show dream interpretation
  showDreamInterpretation(dreamText, interpretation, bot_message_id) {
    // Hide the form and show the result

    $("#dreamForm").addClass("again");
    // Populate the result screen
    $("#dreamResult").append('<div class="user-dream">' + dreamText + "</div>");
    $("#dreamResult").append(
      `<div class="interpretation">
                                              <div class="interpretation-detail">` +
        interpretation +
        `</div>
                                           </div>`
    );
    $("#dreamResult").append(
      `<div class="action-buttons" data-message-id="` +
        bot_message_id +
        `">
                <button class="action-btn copyBtn" title="` +
        window.dreamexplorer.copy_interpretation +
        `">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                    <path stroke-width="1.62" stroke="currentColor" d="M16.6429 17H19C20.6569 17 22 15.6569 22 14V5C22 3.34315 20.6569 2 19 2H10C8.34315 2 7 3.34315 7 5V7"></path>
                    <path stroke-width="1.62" stroke="currentColor" d="M10.5714 22H11.1071M11.1071 22H14C15.6569 22 17 20.6569 17 19V14.5V10C17 8.34315 15.6569 7 14 7H5C3.34315 7 2 8.34315 2 10V12V19C2 20.6569 3.34315 22 5 22H11.1071Z"></path>
                    </svg>
                </button>
                <button class="action-btn likeBtn" title="` +
        window.dreamexplorer.like_this_interpretation +
        `">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                    <path fill="currentColor" d="M5.63506 20.4602H4.18104C2.97856 20.4602 2 19.5728 2 18.4823V9.19563C2 8.10517 2.97856 7.21777 4.18104 7.21777H5.63506C6.83754 7.21777 7.8161 8.10517 7.8161 9.19563V18.4823C7.8161 19.5728 6.83754 20.4602 5.63506 20.4602ZM4.18104 8.53634C3.77973 8.53634 3.45403 8.8317 3.45403 9.19563V18.4823C3.45403 18.8462 3.77973 19.1416 4.18104 19.1416H5.63506C6.03637 19.1416 6.36208 18.8462 6.36208 18.4823V9.19563C6.36208 8.8317 6.03637 8.53634 5.63506 8.53634H4.18104Z"></path>
                    <path stroke-width="0.3" stroke="currentColor" fill="currentColor" d="M16.4914 20.46H15.1253C9.37371 20.46 6.85524 18.5375 6.74976 18.4558C6.46231 18.2316 6.4122 17.8176 6.63768 17.5301C6.86315 17.2427 7.27587 17.1926 7.56331 17.418C7.58309 17.4339 9.88004 19.1414 15.1253 19.1414H16.4914C17.6306 19.1414 18.5945 18.3252 18.7817 17.2018L19.652 11.9842C19.764 11.3091 19.5755 10.6235 19.1325 10.1013C18.6907 9.57914 18.0446 9.27983 17.3616 9.27983H12.8903C12.6464 9.27983 12.4236 9.14533 12.3088 8.93173C12.1941 8.71812 12.206 8.45704 12.3418 8.2553C12.3458 8.24871 12.976 7.25714 12.976 5.63925C12.976 3.93698 12.2561 3.31857 11.7722 3.31857C11.5573 3.31857 11.3133 3.31857 11.3133 4.89558C11.3133 7.865 7.62397 9.86527 7.46706 9.94966C7.14796 10.1198 6.74844 9.99845 6.57571 9.67804C6.40429 9.35762 6.5256 8.9581 6.84601 8.78668C6.87766 8.76954 9.99476 7.07386 9.99476 4.8969C9.99476 3.88292 9.99476 2 11.7722 2C12.6451 2 14.2946 2.76082 14.2946 5.64057C14.2946 6.60445 14.1113 7.39427 13.9135 7.96258H17.3603C18.4323 7.96258 19.445 8.43199 20.1372 9.2495C20.8295 10.0683 21.1261 11.1443 20.9508 12.2005L20.0805 17.418C19.7891 19.181 18.2793 20.46 16.4914 20.46Z"></path>
                    </svg>
                </button>
                <button class="action-btn dislikeBtn" title="` +
        window.dreamexplorer.dislike_this_interpretation +
        `">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                    <path fill="currentColor" d="M18.3649 3.53982L19.819 3.53982C21.0214 3.53982 22 4.42722 22 5.51768L22 14.8044C22 15.8948 21.0214 16.7822 19.819 16.7822L18.3649 16.7822C17.1625 16.7822 16.1839 15.8948 16.1839 14.8044L16.1839 5.51768C16.1839 4.42722 17.1625 3.53982 18.3649 3.53982ZM19.819 15.4637C20.2203 15.4637 20.546 15.1683 20.546 14.8044L20.546 5.51768C20.546 5.15375 20.2203 4.85839 19.819 4.85839L18.3649 4.85839C17.9636 4.85839 17.6379 5.15375 17.6379 5.51768L17.6379 14.8044C17.6379 15.1683 17.9636 15.4637 18.3649 15.4637L19.819 15.4637Z"></path>
                    <path stroke-width="0.3" stroke="currentColor" fill="currentColor" d="M7.50864 3.54001L8.87468 3.54001C14.6263 3.54001 17.1448 5.46249 17.2502 5.54424C17.5377 5.7684 17.5878 6.18243 17.3623 6.46988C17.1368 6.75733 16.7241 6.80743 16.4367 6.58195C16.4169 6.56613 14.12 4.85858 8.87468 4.85858L7.50864 4.85858C6.3694 4.85858 5.40552 5.67478 5.21829 6.7982L4.34803 12.0158C4.23595 12.6909 4.42451 13.3766 4.86755 13.8987C5.30927 14.4209 5.95537 14.7202 6.63839 14.7202L11.1097 14.7202C11.3536 14.7202 11.5764 14.8547 11.6911 15.0683C11.8059 15.2819 11.794 15.543 11.6582 15.7447C11.6542 15.7513 11.024 16.7429 11.024 18.3607C11.024 20.063 11.7439 20.6814 12.2278 20.6814C12.4427 20.6814 12.6867 20.6814 12.6867 19.1044C12.6867 16.135 16.376 14.1347 16.5329 14.0503C16.852 13.8802 17.2516 14.0016 17.4243 14.322C17.5957 14.6424 17.4744 15.0419 17.154 15.2133C17.1223 15.2305 14.0052 16.9261 14.0052 19.1031C14.0052 20.1171 14.0052 22 12.2278 22C11.3549 22 9.70538 21.2392 9.70538 18.3594C9.70538 17.3956 9.88866 16.6057 10.0864 16.0374L6.6397 16.0374C5.56771 16.0374 4.55505 15.568 3.8628 14.7505C3.17055 13.9317 2.87387 12.8557 3.04924 11.7995L3.91949 6.58196C4.2109 4.81903 5.72066 3.54001 7.50864 3.54001Z"></path>
                    </svg>
                </button>
                <button class="action-btn closeBtn" title="` +
        window.dreamexplorer.close_interpretation +
        `">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                    <path fill="currentColor" d="M19.7529 4.24697C20.0648 4.55888 20.0648 5.06459 19.7529 5.3765L5.37626 19.7531C5.06435 20.065 4.55864 20.065 4.24673 19.7531C3.93481 19.4412 3.93481 18.9355 4.24673 18.6236L18.6233 4.24697C18.9353 3.93506 19.441 3.93506 19.7529 4.24697Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M19.7529 4.24697C20.0648 4.55888 20.0648 5.06459 19.7529 5.3765L5.37626 19.7531C5.06435 20.065 4.55864 20.065 4.24673 19.7531C3.93481 19.4412 3.93481 18.9355 4.24673 18.6236L18.6233 4.24697C18.9353 3.93506 19.441 3.93506 19.7529 4.24697Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M19.7529 4.24697C20.0648 4.55888 20.0648 5.06459 19.7529 5.3765L5.37626 19.7531C5.06435 20.065 4.55864 20.065 4.24673 19.7531C3.93481 19.4412 3.93481 18.9355 4.24673 18.6236L18.6233 4.24697C18.9353 3.93506 19.441 3.93506 19.7529 4.24697Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M19.7529 4.24697C20.0648 4.55888 20.0648 5.06459 19.7529 5.3765L5.37626 19.7531C5.06435 20.065 4.55864 20.065 4.24673 19.7531C3.93481 19.4412 3.93481 18.9355 4.24673 18.6236L18.6233 4.24697C18.9353 3.93506 19.441 3.93506 19.7529 4.24697Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M19.7529 4.24697C20.0648 4.55888 20.0648 5.06459 19.7529 5.3765L5.37626 19.7531C5.06435 20.065 4.55864 20.065 4.24673 19.7531C3.93481 19.4412 3.93481 18.9355 4.24673 18.6236L18.6233 4.24697C18.9353 3.93506 19.441 3.93506 19.7529 4.24697Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M19.7529 4.24697C20.0648 4.55888 20.0648 5.06459 19.7529 5.3765L5.37626 19.7531C5.06435 20.065 4.55864 20.065 4.24673 19.7531C3.93481 19.4412 3.93481 18.9355 4.24673 18.6236L18.6233 4.24697C18.9353 3.93506 19.441 3.93506 19.7529 4.24697Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill="currentColor" d="M18.4727 4.09637C18.8678 3.70128 19.5084 3.70128 19.9035 4.09637C20.2986 4.49145 20.2986 5.13202 19.9035 5.52711L5.52686 19.9037C5.13178 20.2988 4.49121 20.2988 4.09612 19.9037C3.70103 19.5086 3.70103 18.8681 4.09612 18.473L18.4727 4.09637ZM19.6023 4.39757C19.3735 4.16884 19.0027 4.16884 18.774 4.39757L4.39733 18.7742C4.16859 19.0029 4.16859 19.3738 4.39733 19.6025C4.62607 19.8313 4.99692 19.8313 5.22566 19.6025L19.6023 5.2259C19.831 4.99716 19.831 4.62631 19.6023 4.39757Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M18.4727 4.09637C18.8678 3.70128 19.5084 3.70128 19.9035 4.09637C20.2986 4.49145 20.2986 5.13202 19.9035 5.52711L5.52686 19.9037C5.13178 20.2988 4.49121 20.2988 4.09612 19.9037C3.70103 19.5086 3.70103 18.8681 4.09612 18.473L18.4727 4.09637ZM19.6023 4.39757C19.3735 4.16884 19.0027 4.16884 18.774 4.39757L4.39733 18.7742C4.16859 19.0029 4.16859 19.3738 4.39733 19.6025C4.62607 19.8313 4.99692 19.8313 5.22566 19.6025L19.6023 5.2259C19.831 4.99716 19.831 4.62631 19.6023 4.39757Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M18.4727 4.09637C18.8678 3.70128 19.5084 3.70128 19.9035 4.09637C20.2986 4.49145 20.2986 5.13202 19.9035 5.52711L5.52686 19.9037C5.13178 20.2988 4.49121 20.2988 4.09612 19.9037C3.70103 19.5086 3.70103 18.8681 4.09612 18.473L18.4727 4.09637ZM19.6023 4.39757C19.3735 4.16884 19.0027 4.16884 18.774 4.39757L4.39733 18.7742C4.16859 19.0029 4.16859 19.3738 4.39733 19.6025C4.62607 19.8313 4.99692 19.8313 5.22566 19.6025L19.6023 5.2259C19.831 4.99716 19.831 4.62631 19.6023 4.39757Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M18.4727 4.09637C18.8678 3.70128 19.5084 3.70128 19.9035 4.09637C20.2986 4.49145 20.2986 5.13202 19.9035 5.52711L5.52686 19.9037C5.13178 20.2988 4.49121 20.2988 4.09612 19.9037C3.70103 19.5086 3.70103 18.8681 4.09612 18.473L18.4727 4.09637ZM19.6023 4.39757C19.3735 4.16884 19.0027 4.16884 18.774 4.39757L4.39733 18.7742C4.16859 19.0029 4.16859 19.3738 4.39733 19.6025C4.62607 19.8313 4.99692 19.8313 5.22566 19.6025L19.6023 5.2259C19.831 4.99716 19.831 4.62631 19.6023 4.39757Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M18.4727 4.09637C18.8678 3.70128 19.5084 3.70128 19.9035 4.09637C20.2986 4.49145 20.2986 5.13202 19.9035 5.52711L5.52686 19.9037C5.13178 20.2988 4.49121 20.2988 4.09612 19.9037C3.70103 19.5086 3.70103 18.8681 4.09612 18.473L18.4727 4.09637ZM19.6023 4.39757C19.3735 4.16884 19.0027 4.16884 18.774 4.39757L4.39733 18.7742C4.16859 19.0029 4.16859 19.3738 4.39733 19.6025C4.62607 19.8313 4.99692 19.8313 5.22566 19.6025L19.6023 5.2259C19.831 4.99716 19.831 4.62631 19.6023 4.39757Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M18.4727 4.09637C18.8678 3.70128 19.5084 3.70128 19.9035 4.09637C20.2986 4.49145 20.2986 5.13202 19.9035 5.52711L5.52686 19.9037C5.13178 20.2988 4.49121 20.2988 4.09612 19.9037C3.70103 19.5086 3.70103 18.8681 4.09612 18.473L18.4727 4.09637ZM19.6023 4.39757C19.3735 4.16884 19.0027 4.16884 18.774 4.39757L4.39733 18.7742C4.16859 19.0029 4.16859 19.3738 4.39733 19.6025C4.62607 19.8313 4.99692 19.8313 5.22566 19.6025L19.6023 5.2259C19.831 4.99716 19.831 4.62631 19.6023 4.39757Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill="currentColor" d="M4.24673 4.24697C4.55864 3.93506 5.06435 3.93506 5.37626 4.24697L19.7529 18.6236C20.0648 18.9355 20.0648 19.4412 19.7529 19.7531C19.441 20.065 18.9353 20.065 18.6233 19.7531L4.24673 5.3765C3.93481 5.06459 3.93481 4.55888 4.24673 4.24697Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M4.24673 4.24697C4.55864 3.93506 5.06435 3.93506 5.37626 4.24697L19.7529 18.6236C20.0648 18.9355 20.0648 19.4412 19.7529 19.7531C19.441 20.065 18.9353 20.065 18.6233 19.7531L4.24673 5.3765C3.93481 5.06459 3.93481 4.55888 4.24673 4.24697Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M4.24673 4.24697C4.55864 3.93506 5.06435 3.93506 5.37626 4.24697L19.7529 18.6236C20.0648 18.9355 20.0648 19.4412 19.7529 19.7531C19.441 20.065 18.9353 20.065 18.6233 19.7531L4.24673 5.3765C3.93481 5.06459 3.93481 4.55888 4.24673 4.24697Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M4.24673 4.24697C4.55864 3.93506 5.06435 3.93506 5.37626 4.24697L19.7529 18.6236C20.0648 18.9355 20.0648 19.4412 19.7529 19.7531C19.441 20.065 18.9353 20.065 18.6233 19.7531L4.24673 5.3765C3.93481 5.06459 3.93481 4.55888 4.24673 4.24697Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M4.24673 4.24697C4.55864 3.93506 5.06435 3.93506 5.37626 4.24697L19.7529 18.6236C20.0648 18.9355 20.0648 19.4412 19.7529 19.7531C19.441 20.065 18.9353 20.065 18.6233 19.7531L4.24673 5.3765C3.93481 5.06459 3.93481 4.55888 4.24673 4.24697Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M4.24673 4.24697C4.55864 3.93506 5.06435 3.93506 5.37626 4.24697L19.7529 18.6236C20.0648 18.9355 20.0648 19.4412 19.7529 19.7531C19.441 20.065 18.9353 20.065 18.6233 19.7531L4.24673 5.3765C3.93481 5.06459 3.93481 4.55888 4.24673 4.24697Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill="currentColor" d="M4.09612 4.09637C4.49121 3.70128 5.13178 3.70128 5.52686 4.09637L19.9035 18.473C20.2986 18.8681 20.2986 19.5086 19.9035 19.9037C19.5084 20.2988 18.8678 20.2988 18.4727 19.9037L4.09612 5.52711C3.70103 5.13202 3.70103 4.49145 4.09612 4.09637ZM5.22566 4.39757C4.99692 4.16884 4.62607 4.16884 4.39733 4.39757C4.16859 4.62631 4.16859 4.99716 4.39733 5.2259L18.774 19.6025C19.0027 19.8313 19.3735 19.8313 19.6023 19.6025C19.831 19.3738 19.831 19.0029 19.6023 18.7742L5.22566 4.39757Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M4.09612 4.09637C4.49121 3.70128 5.13178 3.70128 5.52686 4.09637L19.9035 18.473C20.2986 18.8681 20.2986 19.5086 19.9035 19.9037C19.5084 20.2988 18.8678 20.2988 18.4727 19.9037L4.09612 5.52711C3.70103 5.13202 3.70103 4.49145 4.09612 4.09637ZM5.22566 4.39757C4.99692 4.16884 4.62607 4.16884 4.39733 4.39757C4.16859 4.62631 4.16859 4.99716 4.39733 5.2259L18.774 19.6025C19.0027 19.8313 19.3735 19.8313 19.6023 19.6025C19.831 19.3738 19.831 19.0029 19.6023 18.7742L5.22566 4.39757Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M4.09612 4.09637C4.49121 3.70128 5.13178 3.70128 5.52686 4.09637L19.9035 18.473C20.2986 18.8681 20.2986 19.5086 19.9035 19.9037C19.5084 20.2988 18.8678 20.2988 18.4727 19.9037L4.09612 5.52711C3.70103 5.13202 3.70103 4.49145 4.09612 4.09637ZM5.22566 4.39757C4.99692 4.16884 4.62607 4.16884 4.39733 4.39757C4.16859 4.62631 4.16859 4.99716 4.39733 5.2259L18.774 19.6025C19.0027 19.8313 19.3735 19.8313 19.6023 19.6025C19.831 19.3738 19.831 19.0029 19.6023 18.7742L5.22566 4.39757Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M4.09612 4.09637C4.49121 3.70128 5.13178 3.70128 5.52686 4.09637L19.9035 18.473C20.2986 18.8681 20.2986 19.5086 19.9035 19.9037C19.5084 20.2988 18.8678 20.2988 18.4727 19.9037L4.09612 5.52711C3.70103 5.13202 3.70103 4.49145 4.09612 4.09637ZM5.22566 4.39757C4.99692 4.16884 4.62607 4.16884 4.39733 4.39757C4.16859 4.62631 4.16859 4.99716 4.39733 5.2259L18.774 19.6025C19.0027 19.8313 19.3735 19.8313 19.6023 19.6025C19.831 19.3738 19.831 19.0029 19.6023 18.7742L5.22566 4.39757Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M4.09612 4.09637C4.49121 3.70128 5.13178 3.70128 5.52686 4.09637L19.9035 18.473C20.2986 18.8681 20.2986 19.5086 19.9035 19.9037C19.5084 20.2988 18.8678 20.2988 18.4727 19.9037L4.09612 5.52711C3.70103 5.13202 3.70103 4.49145 4.09612 4.09637ZM5.22566 4.39757C4.99692 4.16884 4.62607 4.16884 4.39733 4.39757C4.16859 4.62631 4.16859 4.99716 4.39733 5.2259L18.774 19.6025C19.0027 19.8313 19.3735 19.8313 19.6023 19.6025C19.831 19.3738 19.831 19.0029 19.6023 18.7742L5.22566 4.39757Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    <path fill-opacity="0.2" fill="currentColor" d="M4.09612 4.09637C4.49121 3.70128 5.13178 3.70128 5.52686 4.09637L19.9035 18.473C20.2986 18.8681 20.2986 19.5086 19.9035 19.9037C19.5084 20.2988 18.8678 20.2988 18.4727 19.9037L4.09612 5.52711C3.70103 5.13202 3.70103 4.49145 4.09612 4.09637ZM5.22566 4.39757C4.99692 4.16884 4.62607 4.16884 4.39733 4.39757C4.16859 4.62631 4.16859 4.99716 4.39733 5.2259L18.774 19.6025C19.0027 19.8313 19.3735 19.8313 19.6023 19.6025C19.831 19.3738 19.831 19.0029 19.6023 18.7742L5.22566 4.39757Z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    </svg>

                </button>
            </div>`
    );
    //this.userDreamDisplay.textContent = dreamText;
    //this.interpretationDetail.textContent = interpretation;

    // Show the result with animation
    this.dreamResult.classList.add("show");
    this.hideStatusMessage();
    $("#dreamText").val("");
    if ($("#dreamText").parents(".again").length == 0) $("#dreamText").css("height", "62px");
    else $("#dreamText").css("height", "64px");
    $("#dreamText").attr("placeholder", window.dreamexplorer.form_dream_placeholder2);
  }

  // Copy feedback (animate button checkmark)
  copyFeedback(button) {
    const originalContent = button.innerHTML;
    button.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 960 960" height="960" width="960"><path color="currentColor" stroke-linejoin="round" stroke-linecap="round" stroke-width="80" stroke="white" d="M800 240L360 680L160 480"></path></svg>';
    button.classList.add("copied");

    setTimeout(() => {
      button.innerHTML = originalContent;
      button.classList.remove("copied");
    }, 1500);
  }

  // Show feedback notification tooltip
  showFeedbackNotification(actionButtons) {
    // Create feedback notification element
    const feedbackNotification = document.createElement("div");
    feedbackNotification.className = "feedback-notification";
    feedbackNotification.textContent = window.dreamexplorer.feedback_appreciated;
    // Styles now provided via CSS class in dream-explorer.css

    // Find the action buttons container and add the notification to it
    if (actionButtons) {
      actionButtons.style.position = "relative";
      actionButtons.appendChild(feedbackNotification);
    } else {
      // Fallback to body if action buttons not found
      document.body.appendChild(feedbackNotification);
    }

    // Fade in
    setTimeout(() => {
      feedbackNotification.style.opacity = "1";
    }, 10);

    // Fade out after 5 seconds
    setTimeout(() => {
      feedbackNotification.style.opacity = "0";
      setTimeout(() => {
        if (feedbackNotification.parentNode) {
          feedbackNotification.parentNode.removeChild(feedbackNotification);
        }
      }, 300);
    }, 5000);
  }

  // Show feedback box
  showFeedbackBox(actionButtonsElement) {
    // Remove any existing feedback box
    $(actionButtonsElement).siblings('.feedback-box').remove();
    
    // Create feedback box HTML
    const feedbackBoxHtml = `
      <div class="feedback-box">
        <div class="feedback-header">
          <h3 class="feedback-title">` + window.dreamexplorer.feedback_title + `</h3>
          <button class="feedback-close-btn">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 6l12 12M6 18L18 6"/>
            </svg>
          </button>
        </div>
        <div class="feedback-options">
          <button class="feedback-tag">` + window.dreamexplorer.feedback_option_title_1 + `</button>
          <button class="feedback-tag">` + window.dreamexplorer.feedback_option_title_2 + `</button>
          <button class="feedback-tag">` + window.dreamexplorer.feedback_option_title_3 + `</button>
          <button class="feedback-tag">` + window.dreamexplorer.feedback_option_title_4 + `</button>
          <button class="feedback-tag">` + window.dreamexplorer.feedback_option_title_5 + `</button>
          <button class="feedback-tag">` + window.dreamexplorer.feedback_option_title_6 + `</button>
        </div>
      </div>
    `;
    
    // Insert feedback box after action buttons
    $(actionButtonsElement).after(feedbackBoxHtml);
  }

  hideStatusMessage() {
    this.statusMessage.classList.remove("show");
  }

  async handleSubmit(e) {
    e.preventDefault();

    const dreamContent = this.dreamText.value.trim();
    if (!dreamContent) {
      this.showStatus(window.dreamexplorer.form_dream_error, "error");
      return;
    }

    this.submitBtn.disabled = true;
    this.showStatus(window.dreamexplorer.form_submitting, "info");

    var first_question = !$("#dreamForm").hasClass("again");

    try {
      // Replace with your actual Shopify endpoint
      const response = await fetch("https://dwshopify-bhcta4hacucegahc.eastus-01.azurewebsites.net/shopify.php", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-Session-Id": this.session_id,
        },
        body: JSON.stringify({
          lang: window.dreamexplorer.lang,
          customer_id: window.dreamexplorer.customer_id,
          conversation_id: this.conversation_id,
          dream: dreamContent,
          timestamp: new Date().toISOString(),
          first_question: first_question,
          ai: 'gpt-4o-mini',
        }),
      });

      if (response.ok) {
        const result = await response.json();
        if (result.status) {
          const htmlContent = marked.parse(result.interpretation);
          this.showDreamInterpretation(dreamContent, htmlContent, result.bot_message_id);
          if (result.session_id) {
            this.session_id = result.session_id;
          }
        } else {
          this.showStatus(window.dreamexplorer.server_error, "error");
        }
      } else {
        this.showStatus(window.dreamexplorer.server_error, "error");
      }
    } catch (error) {
      console.error("Submit error:", error);
      this.showStatus(window.dreamexplorer.server_error, "error");
    } finally {
      this.submitBtn.disabled = false;
      $("#dreamText").val("");
    }
  }

  showStatus(message, type) {
    this.statusMessage.textContent = message;
    this.statusMessage.className = `status-message status-${type} show`;

    setTimeout(() => {
      this.statusMessage.classList.remove("show");
    }, 5000);
  }

  /**
   * Microphone speech to text related functions
   */

  initializeSpeechSDK(onComplete) {
    if (window.SpeechSDK) {
      onComplete(window.SpeechSDK);
      return;
    }

    const tryComplete = () => {
      if (window.SpeechSDK) {
        onComplete(window.SpeechSDK);
        return true;
      }
      return false;
    };

    const sdkScript = document.getElementById("ms-speech-sdk");

    if (sdkScript && !sdkScript.__dwOnloadBound) {
      sdkScript.__dwOnloadBound = true;
      sdkScript.addEventListener("load", () => {
        tryComplete();
      });
    }

    let attempts = 0;
    const maxAttempts = 200; // ~10s fallback
    const intervalId = setInterval(() => {
      if (tryComplete()) {
        clearInterval(intervalId);
      } else if (++attempts >= maxAttempts) {
        clearInterval(intervalId);
        console.warn("SpeechSDK not available after waiting.");
      }
    }, 50);
  }

  async requestAuthorizationToken() {
    if (this.speechTokenEndpoint) {
      try {
        const res = await fetch(this.speechTokenEndpoint);
        const data = await res.json();
        const token = data.token;
        const region = data.region;
        this.regionOptions = region;
        this.speechAuthorizationToken = token;

        console.log("Token fetched from back-end: " + token);

        this.recordBtn.disabled = false;
      } catch (err) {
        console.log(err);
      }
    }
  }

  // Check microphone permission
  async checkMicrophonePermission() {
    try {
      if (navigator.permissions) {
        const permission = await navigator.permissions.query({ name: "microphone" });
        this.microphonePermission = permission.state;

        permission.addEventListener("change", () => {
          this.microphonePermission = permission.state;
          this.updateRecordButtonState();
        });
      }
      this.updateRecordButtonState();
    } catch (error) {
      console.log("Permissions API not supported, will request on first use");
    }
  }

  // Update record button state
  updateRecordButtonState() {
    if (this.microphonePermission === "denied") {
      this.recordBtn.style.opacity = "0.5";
      this.recordBtn.title = window.dreamexplorer.mic_denied;
    } else {
      this.recordBtn.style.opacity = "1";
      this.recordBtn.title = window.dreamexplorer.record_voice;
    }
  }

  // Handle record click
  handleRecordClick() {
    console.log('microphonePermission', this.microphonePermission);
    if (this.microphonePermission === "denied") {
      this.showPermissionInstructions();
      return;
    }

    if (this.microphonePermission === null || this.microphonePermission === "prompt") {
      this.showPermissionModal();
      return;
    }

    this.toggleRecording();
  }

  // Show permission modal
  showPermissionModal() {
    this.permissionModal.classList.add("show");
  }

  // Hide permission modal
  hidePermissionModal() {
    this.permissionModal.classList.remove("show");
  }

  // Request microphone permission
  async requestMicrophonePermission() {
    this.hidePermissionModal();

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      // Stop the stream immediately as we just needed permission
      stream.getTracks().forEach((track) => track.stop());

      this.microphonePermission = "granted";
      this.updateRecordButtonState();
      this.showStatus(window.dreamexplorer.mic_granted, "success");
    } catch (error) {
      console.error("Microphone permission denied:", error);
      this.microphonePermission = "denied";
      this.updateRecordButtonState();
      this.showPermissionInstructions();
    }
  }

  async toggleRecording() {
    if (!this.isRecording) {
      await this.startRecording();
    } else {
      this.stopListening();
    }
  }

   enumerateMicrophones() {
    if (!navigator || !navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        console.log(`Unable to query for audio input devices. Default will be used.\r\n`);
        return;
    }

    navigator.mediaDevices.enumerateDevices().then((devices) => {

        for (const device of devices) {
            if (device.kind === "audioinput") {
                if (!device.deviceId) {
                    window.console.log(
                        `Warning: unable to enumerate a microphone deviceId. This may be due to limitations`
                        + ` with availability in a non-HTTPS context per mediaDevices constraints.`); 
                }
                else {
                   console.log(device.label);
                }
            }
        }
    });
}

  async startRecording() {
    try {

      if(!this.speechAuthorizationToken || !this.regionOptions) {
        console.log('No speechAuthorizationToken or regionOptions');
        return;
      }

      this.dreamTextHidden.value = "";
      this.dreamText.value = "";

      this.speechConfig = window.SpeechSDK.SpeechConfig.fromAuthorizationToken(this.speechAuthorizationToken, this.regionOptions);

      if (window.dreamexplorer.lang == "en") {
        this.speechConfig.speechRecognitionLanguage = "en-US";
      } else {
        this.speechConfig.speechRecognitionLanguage = "pt-BR";
      }

      this.audioConfig = window.SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();

      this.speechRecognizer = new window.SpeechSDK.SpeechRecognizer(this.speechConfig, this.audioConfig);

      this.speechRecognizer.recognizing = (s, e) => {
        this.dreamText.value = this.dreamText.value.replace(/(.*)(^|[\r\n]+).*\[\.\.\.\][\r\n]+/, '$1$2')
                + `${e.result.text} [...]\r\n`;
        this.dreamText.style.height = this.dreamText.scrollHeight + "px";
      };

      this.speechRecognizer.recognized = (s, e) => {
        if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
          this.dreamTextHidden.value += `${e.result.text}\r\n`;
          this.dreamText.value = this.dreamTextHidden.value;
          this.dreamText.style.height = this.dreamText.scrollHeight + "px";
        }
      };

      this.speechRecognizer.canceled = (s, e) => {
        console.error(`Canceled: ${e.reason}`);
        if (e.reason === window.SpeechSDK.CancellationReason.Error) {
          console.error(`Error details: ${e.errorDetails}`);
        }
        this.stopListening();
      };

      this.speechRecognizer.sessionStopped = (s, e) => {
        console.log("Session stopped.");
        this.stopListening();
      };

      this.speechRecognizer.startContinuousRecognitionAsync();

      this.isRecording = true;
      $(".trash-btn").css('display', 'none');
      this.recordBtn.classList.add("recording");
      this.recordBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
<path stroke-width="1.5" stroke="currentColor" d="M8.27783 5.26849V12.2129C8.27783 14.1306 9.8324 15.6852 11.7501 15.6852C13.6677 15.6852 15.2223 14.1306 15.2223 12.2129V5.26849C15.2223 3.35083 13.6677 1.79626 11.7501 1.79626C9.8324 1.79626 8.27783 3.35083 8.27783 5.26849Z"></path>
<path stroke-linecap="round" stroke-width="1.5" stroke="currentColor" d="M5.5 11.9814C5.5 18.4629 11.0556 18.4629 11.9815 18.4629C12.9074 18.4629 18 18.4629 18 11.9814"></path>
<path fill="currentColor" d="M11.2314 21.5C11.2314 21.9142 11.5672 22.25 11.9814 22.25C12.3957 22.25 12.7314 21.9142 12.7314 21.5H11.2314ZM11.9814 18.463H11.2314V21.5H11.9814H12.7314V18.463H11.9814Z"></path>
</svg>`;
      this.showStatus(window.dreamexplorer.recording, "info");
    } catch (error) {
      $(".record-btn").css("display", "flex");
      $(".submit-btn").css("display", "flex");
      console.error("Error accessing microphone:", error);
      this.microphonePermission = "denied";
      this.updateRecordButtonState();

      if (error.name === "NotAllowedError") {
        this.showStatus(window.dreamexplorer.mic_access_denied, "error");
      } else if (error.name === "NotFoundError") {
        this.showStatus(window.dreamexplorer.no_mic, "error");
      } else {
        this.showStatus(window.dreamexplorer.unable_mic, "error");
      }
    }
  }

  stopListening() {
    this.speechRecognizer.stopContinuousRecognitionAsync(() => {
      this.speechRecognizer.close();
      this.speechRecognizer = undefined;
      this.isRecording = false;

      this.recordBtn.classList.remove("recording");
      this.recordBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
      <path stroke-width="1.5" stroke="currentColor" d="M8.27783 5.26849V12.2129C8.27783 14.1306 9.8324 15.6852 11.7501 15.6852C13.6677 15.6852 15.2223 14.1306 15.2223 12.2129V5.26849C15.2223 3.35083 13.6677 1.79626 11.7501 1.79626C9.8324 1.79626 8.27783 3.35083 8.27783 5.26849Z"></path>
      <path stroke-linecap="round" stroke-width="1.5" stroke="currentColor" d="M5.5 11.9814C5.5 18.4629 11.0556 18.4629 11.9815 18.4629C12.9074 18.4629 18 18.4629 18 11.9814"></path>
      <path fill="currentColor" d="M11.2314 21.5C11.2314 21.9142 11.5672 22.25 11.9814 22.25C12.3957 22.25 12.7314 21.9142 12.7314 21.5H11.2314ZM11.9814 18.463H11.2314V21.5H11.9814H12.7314V18.463H11.9814Z"></path>
      </svg>`;

      $(".trash-btn").css('display', 'flex');
    });
  }

  // Show permission instructions
  showPermissionInstructions() {
    let instructions = window.dreamexplorer.mic_instructions_title + "\n\n";

    if (navigator.userAgent.includes("Chrome")) {
      instructions += window.dreamexplorer.mic_instructions_chrome;
    } else if (navigator.userAgent.includes("Firefox")) {
      instructions += window.dreamexplorer.mic_instructions_firefox;
    } else if (navigator.userAgent.includes("Safari")) {
      instructions += window.dreamexplorer.mic_instructions_safari;
    } else {
      instructions += window.dreamexplorer.mic_instructions;
    }

    alert(instructions);
  }
}

// Initialize the dream recorder when the page loads
document.addEventListener("DOMContentLoaded", () => {
  if ($(".dream-recorder-section").length == 1 && $("#dreamText").length == 1) {
    $(".dream-recorder-section").css("opacity", 1);
    dreamWiseEplorerClass = new DreamRecorder();
  } else {
    // Initialize login modal functionality for all users
    initializeLoginModal();
  }
});

// Function to handle login modal functionality
function initializeLoginModal() {
  const dreamFormDisabled = document.getElementById("dreamFormDisabled");
  const needsLoginModal = document.getElementById("needsLoginModal");
  const loginBtn = document.getElementById("loginBtn");
  const cancelLoginBtn = document.getElementById("cancelLoginBtn");

  // Show login modal when disabled form is clicked
  if (dreamFormDisabled) {
    dreamFormDisabled.addEventListener("click", () => {
      if (needsLoginModal) {
        needsLoginModal.classList.add("show");
      }
    });
  }


  // Handle cancel button click
  if (cancelLoginBtn) {
    cancelLoginBtn.addEventListener("click", () => {
      if (needsLoginModal) {
        needsLoginModal.classList.remove("show");
      }
    });
  }
}
